"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageCostsResponseStruct = exports.MessageCosts = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
const messaging_1 = require("../types/messaging");
exports.MessageCosts = (0, superstruct_1.type)({
    count: (0, superstruct_1.number)(),
    amount: (0, superstruct_1.number)(),
    netValue: (0, superstruct_1.number)(),
    serviceFee: (0, superstruct_1.number)(),
    currency: types_1.CurrencyStruct,
    type: messaging_1.MessageTypeEnums,
});
exports.MessageCostsResponseStruct = (0, superstruct_1.type)({
    from: (0, superstruct_1.string)(),
    until: (0, superstruct_1.string)(),
    costs: (0, superstruct_1.array)(exports.MessageCosts),
});
//# sourceMappingURL=MessageCostsResponse.js.map